var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('./loaders');
var io = require('../../libs/socketio');

var reportsArray = prop([]);
var listenersByUid = {};
var durableUids = {};
var refreshTimer = null;

function isTerminalStatus(status) {
  return ['done', 'error', 'expired'].indexOf(status) >= 0;
}

function displayTimestamp(record) {
  var timestamp = Number(record && (record.completedAt || record.createdAt));
  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return record && record.timestamp ? record.timestamp : new Date().toLocaleString();
  }
  return new Date(timestamp).toLocaleString();
}

function normalizeRecord(record) {
  var normalized = Object.assign({}, record || {});
  normalized.uid = normalized.uid ? String(normalized.uid) : '';
  normalized.name = normalized.name || normalized.reportName || 'Report';
  normalized.status = normalized.status || 'processing';
  normalized.timestamp = displayTimestamp(normalized);
  normalized.files = Array.isArray(normalized.files) ? normalized.files : [];
  normalized.urls = Array.isArray(normalized.urls) ? normalized.urls : [];
  return normalized;
}

function upsertRecord(record) {
  var normalized = normalizeRecord(record);
  if (!normalized.uid) return null;
  var current = reportsArray();
  var existing = current.find(function (entry) { return entry.uid === normalized.uid; });
  if (existing) {
    Object.assign(existing, normalized);
    return existing;
  }
  current.unshift(normalized);
  return normalized;
}

function unsubscribe(uid) {
  var listener = listenersByUid[uid];
  if (!listener) return;
  io.off(uid, listener);
  delete listenersByUid[uid];
}

function subscribe(record) {
  if (!record || !record.uid || isTerminalStatus(record.status) || listenersByUid[record.uid]) return;
  var uid = record.uid;
  var listener = function (data) {
    if (!data || String(data.uid || '') !== uid) return;
    var updated = upsertRecord(data);
    if (updated && isTerminalStatus(updated.status)) unsubscribe(uid);
    m.redraw();
  };
  listenersByUid[uid] = listener;
  io.on(uid, listener);
}

reportsArray.track = function track(record) {
  var updated = upsertRecord(record);
  if (updated && isTerminalStatus(updated.status)) unsubscribe(updated.uid);
  else if (updated) subscribe(updated);
  m.redraw();
  return updated;
};

reportsArray.refresh = function refresh() {
  return loaders.requestWithLoader({
    url: '/api/v1/report/executions?limit=50',
    method: 'GET',
    loader: 'background',
    background: true
  }).then(function (records) {
    var returnedUids = {};
    (Array.isArray(records) ? records : []).forEach(function (record) {
      if (!record || !record.uid) return;
      returnedUids[String(record.uid)] = true;
      durableUids[String(record.uid)] = true;
      reportsArray.track(record);
    });

    var staleDurableUids = {};
    Object.keys(durableUids).forEach(function (uid) {
      if (returnedUids[uid]) return;
      staleDurableUids[uid] = true;
      unsubscribe(uid);
      delete durableUids[uid];
    });

    reportsArray(reportsArray().filter(function (record) {
      var uid = record && record.uid ? String(record.uid) : '';
      return !uid || !staleDurableUids[uid];
    }).sort(function (left, right) {
      return (Number(right.createdAt) || 0) - (Number(left.createdAt) || 0);
    }));
    m.redraw();
    return reportsArray();
  }).catch(function () {
    return reportsArray();
  });
};

reportsArray.start = function start() {
  if (refreshTimer) clearInterval(refreshTimer);
  reportsArray.refresh();
  refreshTimer = setInterval(reportsArray.refresh, 5000);
};

reportsArray.stop = function stop() {
  if (refreshTimer) clearInterval(refreshTimer);
  refreshTimer = null;
  Object.keys(listenersByUid).forEach(unsubscribe);
};

reportsArray._private = {
  displayTimestamp: displayTimestamp,
  isTerminalStatus: isTerminalStatus,
  normalizeRecord: normalizeRecord,
  upsertRecord: upsertRecord
};

module.exports = reportsArray;
